import { render, staticRenderFns } from "./MappingWilayahDetail.vue?vue&type=template&id=31dbe6b5&scoped=true"
import script from "./MappingWilayahDetail.vue?vue&type=script&lang=js"
export * from "./MappingWilayahDetail.vue?vue&type=script&lang=js"
import style0 from "./MappingWilayahDetail.vue?vue&type=style&index=0&id=31dbe6b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbe6b5",
  null
  
)

export default component.exports